import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import AppBarSaveActions from '../components/AppBarSaveActions.tsx';
import OpportunityProfileForm from './OpportunityProfileForm.tsx';

const OpportunityProfileEdit: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/opportunities">
          Opportunities
        </MuiLink>
        <Typography color="text.primary">Profile</Typography>
      </Breadcrumbs>
      <Edit mutationMode="pessimistic">
        <SimpleForm toolbar={<AppBarSaveActions />}>
          <Container maxWidth="md">
            <Typography variant="h5" gutterBottom>
              Opportunity Profile
            </Typography>
            <OpportunityProfileForm />
          </Container>
        </SimpleForm>
      </Edit>
    </Container>
  );
};

export default OpportunityProfileEdit;
